// Agentic content generation: the article is created InProgress and filled in later by the
// Function (meta) and the AI-Agent (content), so the client only queues it and polls status.
export class AgenticGenerationConfig {
  isEnabled: boolean = false;
  excludedTemplates: string[] = [];
}

export class AgenticGenerationResponse {
  success: boolean;
  errorCode: number;
  message: string;
  jobId: string;
  articleId: number;
  documentId: string;
  templateId: number;
  templateTitle: string;
  status: string;
}

export class AgenticGenerationStatus {
  articleId: number;
  jobId: string;
  status: string;
  attempts: number;
  failureReason: string;
  canRetry: boolean;
  queuedAt: string;
  completedAt: string;
}

export class GetAgenticGenerationStatusResponse {
  success: boolean;
  errorCode: number;
  message: string;
  jobs: AgenticGenerationStatus[] = [];
}

export const AgenticGenerationJobStatus = {
  QUEUED: 'Queued',
  META_GENERATED: 'MetaGenerated',
  COMPLETED: 'Completed',
  FAILED: 'Failed'
};
